import { render, staticRenderFns } from "./Atention.vue?vue&type=template&id=db5d68ac&scoped=true&lang=pug&"
import script from "./Atention.vue?vue&type=script&lang=js&"
export * from "./Atention.vue?vue&type=script&lang=js&"
import style0 from "./Atention.vue?vue&type=style&index=0&id=db5d68ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5d68ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db5d68ac')) {
      api.createRecord('db5d68ac', component.options)
    } else {
      api.reload('db5d68ac', component.options)
    }
    module.hot.accept("./Atention.vue?vue&type=template&id=db5d68ac&scoped=true&lang=pug&", function () {
      api.rerender('db5d68ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/older_adult/Atention.vue"
export default component.exports